import Vue from 'vue'

export const weeklyBids = data => Vue.axios.post('stat/weeklyBids', data)
export const getAdvertStats = params => Vue.axios.get('stat/adverts', { params })
export const getAdvertStatsActivations = params => Vue.axios.get('stat/adverts/activations', { params })
export const getOccupationDetails = (occupationName, params) => Vue.axios.get(`stat/adverts/${occupationName}`, { params })
export const getOccupationActivationDetails = (occupationName, params) => Vue.axios.get(`stat/adverts/activations/${occupationName}`, { params })
export const getAdvertOccupations = params => Vue.axios.get('occupations/stat/adverts', { params })
export const getAggregatedAdWatches = params => Vue.axios.get('stat/adwatches/aggregated', { params })
export const getAdWatchStats = params => Vue.axios.get('stat/adwatches', { params })
export const getAdWatchStatsActivations = params => Vue.axios.get('stat/adwatches/activations', { params })
export const getAdWatchCities = occupationName => Vue.axios.get(`stat/adwatches/${occupationName}/cities`)
export const getOfferStats = params => Vue.axios.get('stat/offers', { params })
export const getOfferDetails = (occupationName, params) => Vue.axios.get(`stat/offers/${occupationName}`, { params })
export const getEmployerSearchOccupations = params => Vue.axios.get('occupations/stat/employerSearch', { params })
export const getUserCount = () => Vue.axios.get('stat/users')
export const getWorkLocations = () => Vue.axios.get('stat/workLocations')

export const getUnModeratedEmployerSearchOccupations = params => Vue.axios.get('occupations/stat/employerSearch/unModerated')
export const updateEmployerSearchOccupation = (name, data) => Vue.axios.put(`occupations/stat/employerSearch/${name}`, data)
export const deleteEmployerSearchOccupation = name => Vue.axios.delete(`occupations/stat/employerSearch/${name}`)



// WEBPACK FOOTER //
// ./src/services/stat.js